// src/hooks/useUserProfile.js
// Mengelola profil user (nama) yang disimpan di localStorage

import { useState, useEffect } from 'react';

const STORAGE_KEY_NAME = 'nahwu_ai_user_name';

const DEFAULT_PROFILE = {
  name: 'Santri',  // Default jika belum ada nama
};

export function useUserProfile() {
  const [profile, setProfile] = useState(DEFAULT_PROFILE);
  const [isLoaded, setIsLoaded] = useState(false);

  // ── Load dari localStorage saat mount ────────────────
  useEffect(() => {
    try {
      const savedName = localStorage.getItem(STORAGE_KEY_NAME) || '';
      setProfile({
        name: savedName.trim() || DEFAULT_PROFILE.name,
      });
    } catch (err) {
      console.error('Failed to load user profile:', err);
      setProfile(DEFAULT_PROFILE);
    } finally {
      setIsLoaded(true);
    }
  }, []);

  // ── Simpan ke localStorage ───────────────────────────
  const saveProfile = (newName) => {
    const cleanName = (newName || '').trim() || DEFAULT_PROFILE.name;
    try {
      localStorage.setItem(STORAGE_KEY_NAME, cleanName);
      setProfile({ name: cleanName });
      return cleanName;
    } catch (err) {
      console.error('Failed to save user profile:', err);
      return null;
    }
  };

  // ── Hapus profil (reset) ─────────────────────────────
  const clearProfile = () => {
    try {
      localStorage.removeItem(STORAGE_KEY_NAME);
      setProfile(DEFAULT_PROFILE);
    } catch (err) {
      console.error('Failed to clear user profile:', err);
    }
  };

  return {
    profile,
    isLoaded,
    saveProfile,
    clearProfile,
  };
}

export default useUserProfile;